import React from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Form,
    Row,
    Col,
    Select,
    DatePicker, Input,
} from 'antd';
const FormItem = Form.Item;
import {formatFormData} from './utils';
import { actions, asyncGet ,asyncGetMonitorList} from './reducers';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const spans = {
    xs: 14,
    sm: 14,
    md: 6,
    lg: 6,
    xl: 6,
};

class Search extends React.Component {
    constructor(props) {
        super(props);
        //执行父组件的方法，将this传过去
        this.props.handleSearch(this)
    }

    handleReset= () => {
        this.props.form.resetFields();
    }

    // 查询
    handleSearch = () => {
        let values = this.props.form.getFieldsValue();
        for (let i in values) {
            if (values[i] == -1 || values[i] === '' || values[i] === undefined) {
                delete values[i];
            }
        }
        console.log('=====searchValue', values);
        this.props.changeSearchValues(formatFormData(values));
        this.props.resetPagination();
        if(this.props.uiStatus.onSelectTab == "1"){
           this.props.asyncGet();
        }else{
            this.props.asyncGetEvs();
        }
    }
    addTaskNote = () =>{
        this.props.addShow();
    }
    sendCommend = () => {
        // 下发命令
        this.props.editShow();
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const {taskMonitorList} = this.props;
        let taskMonitorList1 = new Array();
        taskMonitorList.forEach(
          taskInfo =>{
              taskMonitorList1.push(taskInfo['monitoringName']);
          }
        );
        let i =0;
        const taskMonitorList2 = taskMonitorList1.map(item => {
            return (
                <Option key={i} value={item}>
                    {item}
                </Option>
            );
            i++;
        });
        const dateFormat = 'YYYY-MM-DD';
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>任务执行数据</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={4}>
                            <FormItem {...spans} label="开始时间">
                                {getFieldDecorator('beginTime', {
                                    //initialValue: moment(moment().format(dateFormat)),
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入开始时间',
                                        },
                                    ],
                                }
                                )(<DatePicker format={dateFormat} />)}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem {...spans} label="结束时间">
                                {getFieldDecorator('endTime', {
                                   // initialValue: moment(moment().format(dateFormat)),
                                }
                                )(<DatePicker format={dateFormat} />)}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="eId" {...spans}>
                                {getFieldDecorator('eId')(
                                    <Input placeholder="请输入"/>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="taskId" {...spans}>
                                {getFieldDecorator('taskId')(
                                    <Input placeholder="请输入整数"/>

                                )}
                            </FormItem>
                        </Col>
                        <Col span={4}>
                            <FormItem label="检测公司" {...spans}>
                                {getFieldDecorator('monitoringName')(
                                    <Select allowClear placeholder="全部" style={{ width: 160 }}>
                                        {taskMonitorList2}
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ margin: '0 8px' }} onClick={this.handleReset}>
                                重置
                            </Button>
                            <Button type="primary" onClick={this.handleSearch} style={{ margin: '0 8px' }}>
                                搜索
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    pricpleList: state.taskExcuteData.pricpleList,
    taskMonitorList: state.taskExcuteData.taskMonitorList,
    uiStatus: state.taskExcuteData.uiStatus,
});

const mapDispatchToProps = dispatch => ({
    changeSearchValues: values => dispatch(actions.changeSearchValues(values)),
    resetPagination: () => dispatch(actions.changePagination({ current: 1 })),
    asyncGet: () => dispatch(asyncGet()),
    editShow: () => dispatch(actions.changeUiStatus({ isSendCommend: true })),
    addShow: () =>  dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    asyncGetMonitorList: ()=> dispatch(asyncGetMonitorList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Search));



// WEBPACK FOOTER //
// ./pages/monitor/taskExcuteData/search.js